import { Component, Input, OnInit } from '@angular/core';
import * as moment from "moment";
import { DocumentService } from 'src/services/document.service';


@Component({
  selector: 'app-card-exames-component',
  templateUrl: './card-exames-component.component.html',
  styleUrls: ['./card-exames-component.component.scss'],
})
export class CardExamesComponentComponent implements OnInit {

  @Input("data") exame;
  @Input("ultimo") ultimo;

  constructor(
    private document: DocumentService
  ) { }

  ngOnInit() { }

  abrirItem() {
    this.exame.selecionado = !this.exame.selecionado;
  }

  dateLabel(date: string) {
    return `${moment(date).format("L")}`;
  }

  async downloadExame(event) {
    await this.document.download(this.exame);

    event.stopPropagation();
  }

}
